<template>
    <div class="black-container">
        <dv-loading style="position: absolute; left: 0; right: 0; color: #ffff"
            >Loading...</dv-loading
        >
    </div>
</template>
<script>
export default {
    mounted() {
        this.$nextTick(() => {
            if (this.$route.query && this.$route.query.url) {
                // this.$router.push(this.$route.query.url);
                const { href } = this.$router.resolve({
                    path: this.$route.query.url,
                });
                window.location.href = href;
            }
        });
    },
};
</script>
<style lang="scss">
.black-container {
    width: 100%;
    height: 100%;
    background: #000;
}
</style>